import React from 'react'
import Navbar from '../HomePage/Navbar';
import ContactUs from './ContactUs';
function ContactUsIndex() {
  return (
    <div>
      <Navbar />
      <ContactUs />

    </div>
  )
}

export default ContactUsIndex
